import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styles from './icon.module.css';
import clsx from 'clsx';
export var Icon = function (_a) {
    var icon = _a.icon, color = _a.color, size = _a.size, extraClass = _a.extraClass;
    var iconSize = typeof size === 'undefined' ? '' : "icon-".concat(size);
    return (_jsx(_Fragment, { children: _jsx("i", { className: clsx(styles.icon, "icon-".concat(icon), styles[iconSize], extraClass), style: typeof color === 'undefined'
                ? {}
                : { color: "var(--color-".concat(color, ")") } }) }));
};
export default Icon;
